import {OptionsTable} from "./components/OptionsTable";
import {ProductsTable} from "./components/ProductsTable";
import {useCalculatorContext} from "./context";

// Content
export function Content() {
  const {state: {
    currentProducts,
    serviceOptions,
  },
  } = useCalculatorContext();


  return (
    <>
      <ProductsTable items={currentProducts} />
      <br />
      <OptionsTable items={serviceOptions} />
    </>
  )
}
